(function () {
  var modal;
  var iframe;
  var closeButton;
  var lastTrigger;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  function getVideoId(holder) {
    if (!holder) return '';
    return holder.dataset.id || holder.dataset.videoid || '';
  }

  function safeReplaceChildren(parent, node) {
    if (!parent) return;
    if (typeof parent.replaceChildren === 'function') {
      parent.replaceChildren(node);
    } else {
      while (parent.firstChild) parent.removeChild(parent.firstChild);
      parent.appendChild(node);
    }
  }

  function buildEmbedUrl(id, start) {
    var qs = new URLSearchParams({
      rel: '0',
      modestbranding: '1',
      playsinline: '1',
      autoplay: '1'
    });
    if (start) qs.set('start', String(start));
    return 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?' + qs.toString();
  }

  function ensureModal() {
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'youtube-embed-modal';
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Video player');

    var dialog = document.createElement('div');
    dialog.className = 'youtube-embed-modal__dialog';

    closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'youtube-embed-modal__close';
    closeButton.setAttribute('aria-label', 'Close video');
    closeButton.innerHTML = '&times;';

    var ratio = document.createElement('div');
    ratio.className = 'youtube-embed-modal__ratio';

    iframe = document.createElement('iframe');
    iframe.className = 'youtube-embed-modal__frame';
    iframe.title = 'YouTube video player';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';

    ratio.appendChild(iframe);
    dialog.appendChild(closeButton);
    dialog.appendChild(ratio);
    modal.appendChild(dialog);
    document.body.appendChild(modal);

    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
    closeButton.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && !modal.hidden) closeModal();
    });

    return modal;
  }

  function openModal(id, start, title, trigger) {
    ensureModal();
    if (!id || !iframe) return;

    lastTrigger = trigger || null;
    iframe.title = title || 'YouTube video player';
    iframe.src = buildEmbedUrl(id, start);
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    if (closeButton) closeButton.focus({ preventScroll: true });
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    if (iframe) iframe.src = '';
    document.documentElement.style.overflow = '';
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus({ preventScroll: true });
    }
    lastTrigger = null;
  }

  function mountNode(holder) {
    if (!holder || holder.dataset.mounted === '1') return;

    var id = getVideoId(holder);
    if (!id) return;

    var start = parseInt(holder.dataset.start || '0', 10) || 0;
    var ratio = (holder.dataset.ratio || '').replace('x', '/');
    var maxw = holder.dataset.maxwidth || '';
    var cover = /^(1|true|yes)$/i.test(holder.dataset.cover || '');
    var modalMode = /^(1|true|yes)$/i.test(holder.dataset.modal || '');
    var title = holder.dataset.title
      || (holder.querySelector && holder.querySelector('a') && holder.querySelector('a').textContent.trim())
      || 'YouTube video player';

    var box = document.createElement('div');
    box.className = 'youtube-embed';

    ['--yt-ratio', '--yt-maxw', '--yt-btn-w', '--yt-btn-h'].forEach(function (variable) {
      var val = getComputedStyle(holder).getPropertyValue(variable);
      if (val) box.style.setProperty(variable, val.trim());
    });
    if (ratio) box.style.setProperty('--yt-ratio', ratio);
    if (maxw) box.style.setProperty('--yt-maxw', /^\d+$/.test(maxw) ? (maxw + 'px') : maxw);
    if (cover) box.classList.add('is-cover');

    var thumb = document.createElement('div');
    thumb.className = 'youtube-embed__thumb';
    thumb.style.backgroundImage = 'url(https://i.ytimg.com/vi/' + id + '/hqdefault.jpg)';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'youtube-embed__play';
    btn.setAttribute('aria-label', title);

    btn.addEventListener('click', function () {
      if (modalMode) {
        openModal(id, start, title, btn);
        return;
      }

      var inlineFrame = document.createElement('iframe');
      inlineFrame.src = buildEmbedUrl(id, start);
      inlineFrame.title = title;
      inlineFrame.loading = 'lazy';
      inlineFrame.referrerPolicy = 'strict-origin-when-cross-origin';
      inlineFrame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      inlineFrame.allowFullscreen = true;
      safeReplaceChildren(box, inlineFrame);
    }, { once: !modalMode });

    box.appendChild(thumb);
    box.appendChild(btn);

    holder.dataset.mounted = '1';
    holder.replaceWith(box);
  }

  function mountAll(root) {
    (root || document).querySelectorAll('.youtubevideo[data-id], .youtubevideo[data-videoid]').forEach(mountNode);
  }

  ready(function () {
    mountAll();
    setTimeout(mountAll, 300);
  });

  if ('MutationObserver' in window) {
    var obs = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        (m.addedNodes || []).forEach(function (n) {
          if (n && n.nodeType === 1) mountAll(n);
        });
      });
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
